import { forwardRef } from 'react'
import { closeSnackbar, SnackbarContent, SnackbarKey } from 'notistack'
import Close from '@mui/icons-material/Close'
import { IconButton, Paper, Tooltip } from '@mui/material'
import { useGetDocument } from '@/service-library/hooks/documents'
import { useSetNotificationReadState } from '@/service-library/hooks/notifications'
import { Notification } from '@/types/notifications'
import NotificationButton from './NotificationButton'

type NotificationPopupProps = {
  id: SnackbarKey
  notification: Notification
}

const NotificationPopup = forwardRef<HTMLDivElement, NotificationPopupProps>(
  function NotificationPopup({ id, notification }, ref) {
    const { setNotificationReadState } = useSetNotificationReadState()
    const { document, isPending } = useGetDocument({
      id: notification.link_obj_id ?? '',
      filters: { fields__only: 'id,name' },
    })

    return (
      <SnackbarContent ref={ref}>
        <Paper
          elevation={6}
          sx={{ position: 'relative', width: 400, maxWidth: '100%' }}
        >
          <NotificationButton
            notification={notification}
            isRead={false}
            onClick={() => {
              setNotificationReadState({ id: notification.id, read: true })
              closeSnackbar(id)
            }}
            documentName={document?.name}
            documentLoading={isPending}
            sx={{ pr: 5, borderRadius: 1 }}
          />
          <Tooltip title="Dismiss">
            <IconButton
              aria-label="Dismiss"
              size="small"
              onClick={() => closeSnackbar(id)}
              sx={{ position: 'absolute', top: 6, right: 6, p: 0.5 }}
            >
              <Close fontSize="small" />
            </IconButton>
          </Tooltip>
        </Paper>
      </SnackbarContent>
    )
  },
)

export default NotificationPopup
